import {
  extractType,
  getFunnelConversionInterval,
  getGlobalFilter,
  getProjectZoneId,
  getSelectedFunnel,
  isFunnelManualEnabled,
} from '../reducers/analyticsApp';
import { toFilter } from './filterConverter';
import { transformStep } from '../actions/common';
import { fromCompound, fromFunnelResult } from './compoundConverter';

export const buildFunnelQuery = (state) => {
  const timezone = getProjectZoneId(state);
  const globalFilter = toFilter(getGlobalFilter(state));
  const selectedFunnel = getSelectedFunnel(state);
  const steps = selectedFunnel.steps.map(transformStep);
  const conversionInterval = getFunnelConversionInterval(state);

  return {
    timezone,
    globalFilter,
    steps,
    filter: selectedFunnel.dateRange ? { ...selectedFunnel.dateRange } : null,
    conversionInterval,
  };
};

export const getFunnelInfo = (state) => {
  const selectedFunnel = getSelectedFunnel(state);
  const funnelManualEnabled = isFunnelManualEnabled(state);

  return { selectedFunnel, funnelManualEnabled };
};

export const fromFunnelExecuteResponse = (response, query, funnelInfo) => {
  const { selectedFunnel, funnelManualEnabled } = funnelInfo;

  return {
    result: fromFunnelResult(response, query, selectedFunnel),
    manualEnabled: funnelManualEnabled,
  };
};

export const getFunnelsInfo = (state) => {
  const typeExtractor = (event, field) => extractType(state, event, field);

  return { typeExtractor };
};

export const fromFunnelResponse = (response, funnelsInfo) => {
  const { typeExtractor } = funnelsInfo;

  return fromCompound(response, typeExtractor);
};
